// extracted by mini-css-extract-plugin
export default {"title":"ThirdScreen_title__LFW4K","row":"ThirdScreen_row__350f0","description":"ThirdScreen_description__okVz5","more":"ThirdScreen_more__fFsNn"};